export default __webpack_public_path__ + "580de6aed7998f1e93ec469e9a88c3d4.wav";